import { Component, OnInit } from '@angular/core';
import { DVFormGroup, DVFormControl, DVFormArray } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ExperiencesService } from '../experiences.service';
import { SnotifyService } from 'ng-snotify';
import moment from 'moment';

@Component({
  selector: 'app-add-online-experience',
  templateUrl: './add-online-experience.component.html',
  styleUrls: ['./add-online-experience.component.css']
})
export class AddOnlineExperienceComponent implements OnInit {

  experienceForm: DVFormGroup;
  isAddState = true;

  daysOfWeek = moment.weekdays().map((week, i) => ({
    value: i,
    display: week
  }));


  constructor(
    public route: ActivatedRoute,
    private experienceApi: ExperiencesService,
    private notifier: SnotifyService,
    private router: Router
  ) {
    this.experienceForm = new DVFormGroup({
      id: new DVFormControl(null),
      name: new DVFormControl(null, {
        'name is required': Validators.required
      }),
      tagline: new DVFormControl(''),
      videoUrl: new DVFormControl('', {
        // tslint:disable-next-line: max-line-length
        'This link is not valid': Validators.pattern('(https?://)?(www\\.)?(yotu\\.be/|youtube\\.com/)?((.+/)?(watch(\\?v=|.+&v=))?(v=)?)([\\w_-]{11})(&.+)?')
      }),
      description: new DVFormControl(null, {
        'Description is required': Validators.required
      }),
      relatedExperienceIds: new DVFormControl([]),
      tags: new DVFormControl(null, {
        'Tags are required': Validators.required
      }),
      metaKeywords: new DVFormControl(null),
      metaDescription: new DVFormControl(null),
      metaTitle: new DVFormControl(null),
      countryId: new DVFormControl(null, {
        'Country is required': Validators.required
      }),
      cityId: new DVFormControl(null, {
        'City is required': Validators.required
      }),
      maximumCapacity: new DVFormControl(null, {
        'Maximum Capacity is required': Validators.required
      }),
      startDate: new DVFormControl(null, {
        'Start Date is required': Validators.required
      }),
      endDate: new DVFormControl(null, {
        'End Date is required': Validators.required
      }),
      localId: new DVFormControl(null, {
        'Local is required': Validators.required
      }),
      active: new DVFormControl(),
      OnlineExperienceDetails: new DVFormGroup({
        sessionsPerDay: new DVFormControl(null, {
          'Sessions per day is required': Validators.required,
        }),
        durationInMinutes: new DVFormControl(null, {
          'Duration is required': Validators.required
        }),
        sessionStartTime: new DVFormControl(null, {
          'Sessions Start time is required': Validators.required
        }),
        communicationPlatformInfo: new DVFormControl(null, {
          'this field is required': Validators.required
        }),
        confirmationEmailWillContain: new DVFormControl(null, {
          'this field is required': Validators.required
        }),
        stuffToPrepare: new DVFormControl([], {
          'This field is required': Validators.required
        }),
        availableDays: new DVFormControl(null, {
          'Available Days is required': Validators.required
        }),
        breaksDurationInMinutes: new DVFormControl(60, {
          'this field is required': Validators.required
        }),
        utcOffset: new DVFormControl(moment().format('Z'))
      }),
      ExperienceCancellationPolicies: new DVFormArray(
        [],
        [
          {
            name: 'id',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'days',
            type: 'CONTROL',
            default: null,
            validators: {
              'Number of days is required': Validators.required
            }
          },
          {
            name: 'percentage',
            type: 'CONTROL',
            default: null,
            validators: {
              'Percentage is required': Validators.required
            }
          }
        ],
        0,
        {
          'Cancellation Policies is required': Validators.required
        }
      ),
      Price: new DVFormArray(
        [],
        [
          {
            name: 'id',
            type: 'CONTROL',
            default: null
          },
          {
            name: 'from',
            type: 'CONTROL',
            default: 0,
            validators: {
              'Number of travelers is required': Validators.required
            }
          },
          {
            name: 'to',
            type: 'CONTROL',
            default: 1,
          },
          {
            name: 'amount',
            type: 'CONTROL',
            default: 0,
            validators: {
              'Amount is required': Validators.required
            }
          }
        ],
        0,
        {
          'Prices are required': Validators.required
        }
      ),
      ExperiencePictures: new DVFormControl([], {
        'Slider Images are required': Validators.required,
        // 'You must upload at least two images': Validators.minLength(2)
      })
    });
  }

  ngOnInit() {
    this.route.url.subscribe((url) => {
      if (
        url.toString().includes('edit') &&
        this.route.snapshot.params.id
      ) {
        this.isAddState = false;
        this.initiateEditMode();
      } else {
        this.isAddState = true;
      }
    });
  }

  formSubmit(active?: boolean) {
    if (this.experienceForm.valid) {
      const formResult = this.experienceForm.getCleanValue();
      formResult.tagline = formResult.tagline ? formResult.tagline : null;
      formResult.videoUrl = formResult.videoUrl ? formResult.videoUrl : null;
      formResult.metaKeywords = formResult.metaKeywords ? formResult.metaKeywords : null;
      formResult.metaDescription = formResult.metaDescription ? formResult.metaDescription : null;
      formResult.metaTitle = formResult.metaTitle ? formResult.metaTitle : null;

      formResult.tags = formResult.tags.map(tag => tag.id);
      formResult.relatedExperienceIds = formResult.relatedExperienceIds ? formResult.relatedExperienceIds.map(exp => exp.value) : [];
      formResult.OnlineExperienceDetails.availableDays = formResult.OnlineExperienceDetails.availableDays.map(day => day.value);
      if (this.isAddState) {
        this.performAddOperation(formResult, active);
      } else {
        this.performEditOperation(formResult, formResult.id);
      }
    } else {
      this.experienceForm.forceShowErrors();
    }
  }

  private initiateEditMode() {
    const experienceId = this.route.snapshot.params.id;
    this.experienceApi.getSingleExperienceById(experienceId).subscribe(response => {
      const experienceBody = response.data.experience;
      experienceBody.countryId = experienceBody.City.countryId;
      experienceBody.tags = experienceBody.Tags;
      experienceBody.startDate = moment(experienceBody.startDate).format('YYYY-MM-DD');
      experienceBody.endDate = moment(experienceBody.endDate).format('YYYY-MM-DD');
      experienceBody.localId = experienceBody.Locals ? experienceBody.Locals[0].uuid : null;
      experienceBody.relatedExperienceIds = experienceBody.RelatedExperiences.map((exp: any) => {
        return {
          value: exp.id,
          display: exp.name
        };
      });
      experienceBody
        .OnlineExperienceDetails.availableDays = experienceBody
          .OnlineExperienceDetails.availableDays
          .map(dayId => this.daysOfWeek.find(day => day.value === dayId));
      this.experienceForm.patchValue(experienceBody);
    });
  }

  private performAddOperation(experienceFormBody, active) {
    experienceFormBody = {
      active,
      ...experienceFormBody
    };
    this.experienceApi.addOnlineExperience(experienceFormBody).subscribe(response => {
      this.notifier.success('Experience Added Successfully');
      this.router.navigate(['experiences/list']);
    }, error => {
      this.notifier.error(error.error.userMessage);
    });
  }

  private performEditOperation(experienceFormBody, experienceId) {
    this.experienceApi.updateOnlineExperience(experienceId, experienceFormBody).subscribe(response => {
      this.notifier.success('Experience updated successfully');
      this.router.navigate(['experiences/list']);
    }, error => {
      this.notifier.error(error.error.userMessage);
    });
  }

}
